import { APP_VERSION } from './version';

export function getAppVersion() {
  // Priority 1: Runtime config (set by CI/CD during deployment)
  if (typeof window !== 'undefined' && window.__HUB_CONFIG__ && window.__HUB_CONFIG__.version) {
    return window.__HUB_CONFIG__.version;
  }
  // Priority 2: Build-time environment variable (set during build)
  if (import.meta.env.VITE_APP_VERSION) {
    return import.meta.env.VITE_APP_VERSION;
  }
  // Priority 3: Default fallback from version.js
  if (APP_VERSION) {
    return APP_VERSION;
  }
  return 'N/A';
}
